export enum WidgetType {
  table = 'tableWidget',
  grid = 'gridWidget',
  list = 'listWidget',
  graph = 'graghWidget',
  personalDetails = 'personalDetailsWidget',
  hotlinks = 'hotlinksWidget',
  events = 'eventsWidget',
  portfolioSummary = 'portfolioSummaryWidget',
  chart = 'chartWidget',
  bankAccounts = 'bankAccountsWidget',
  doughnutChart = 'doughnutChart',
  lineChart = 'lineChart',
  gaugeChart = 'gaugeChart',
  bookSummary = 'bookSummaryWidget',
  topFunds = 'topFundsWidget',
  topAssetManagers = 'topAssetManagersWidget',
  todoList = 'todoListWidget',
  caseTracking = 'caseTrackingWidget',
  latestTransactions = 'latestTransactionsWidget',
  investmentBreakdown = 'investmentBreakdownWidget',
  beneficiaries = 'beneficiariesWidget',
  unknown = 'unknown'
}

export enum ToDoListTab {
  due = 'due',
  overdue = 'overdue',
  notCompliant = 'notCompliant'
}

export enum StatusPillColour {
  blue,
  amber,
  red
}

export enum NegativeJourneyCategory {
  search,
  filter,
  manyFilters
}

export enum SelectedFilterCategory {
  toDoItem,
  status
}
export enum toDoListTableHeaderKeys {
  clientName = 'clientName',
  investmentNumber = 'investmentNumber',
  investmentName = 'investmentName',
  toDoItem = 'toDoItem',
  dueDate = 'dueDate',
  status = 'status'
}
